<div
  class="create-post-container"
  [class.create-post-active]="createPostActive"
  (onFileDrop)="droppedFile($event)"
  ng2FileDrop
  [uploader]="uploader"
  (fileOver)="fileOverBase($event)"
  [class.hovering]="hasBaseDropZoneOver"
>
  @if ((communityService.profile?.public && user.active_subscription) || betaStringId) {
    <div class="d-flex">
      <!-- <img [src]="userService.profilePicture" class="profile-photo" alt="" /> -->
      <div class="w-full form-group m-b-0">
        <label id="start-post-label" class="control-label" for="post-input">{{ "com.start_new_post" | translate }}</label>
        @if (betaStringId) {
          <div class="m-b-10">
            <myp-message-input
              #subjectInput
              [type]="'span'"
              inputID="post-subject-input"
              (valueChanged)="postSubjectContentChanged($event)"
              (focus)="postInputFocus('subject')"
              (blur)="postInputBlur()"
              [placeholder]="'Enter a subject for your post...'"
              [backgroundColor]="appService.activeTheme == 'dark' ? '#2e2e2e' : '#e9e9e9'"
              [shouldDetectContent]="false"
              [includeSendButton]="false"
              [mentionSource]="betaStringId ? false : 'community_profiles'"
            ></myp-message-input>
          </div>
        }
        <myp-message-input
          #msgInput
          [type]="'span'"
          inputID="post-input"
          (valueChanged)="postContentChanged($event)"
          (returnPressed)="sendPost()"
          (focus)="postInputFocus('post')"
          (blur)="postInputBlur()"
          [useQuill]="betaStringId"
          [placeholder]="betaStringId ? 'Enter a body for your post...' : 'Start typing...'"
          [shouldDetectContent]="true"
          [includeSendButton]="false"
          [backgroundColor]="appService.activeTheme == 'dark' ? '#2e2e2e' : '#e9e9e9'"
          [mentionSource]="betaStringId ? false : 'community_profiles'"
          ariaLabelBy="start-post-label"
          (openUploadImage)="attachFile(false, $event)"
        ></myp-message-input>
      </div>
    </div>
    @if (elligibleMentions && elligibleMentions.length) {
      @for (user of elligibleMentions; track user) {
        <button class="mention-option d-flex m-y-10 align-items-center" [class.selected]="user.selected" (click)="selectMention(user)">
          <img [src]="user.photo || './assets/images/default_avatar.jpg'" class="profile-photo tiny m-r-5" alt="user photo" />
          <span class="bold t-14">{{ user.firstName + " " + user.lastName }}</span>
        </button>
      }
    }
    @if (msgInput.selectedArticlesInMessage && msgInput.selectedArticlesInMessage.length) {
      <div>
        @for (item of msgInput.selectedArticlesInMessage; track item) {
          <button class="comment-article-attachment" (click)="showArticle(item)">
            <fa-icon icon="newspaper" class="icon"></fa-icon>
            <div>
              <span class="bold">{{ item.article.name }}</span>
              <br />
              <span class="t-12 text-muted">{{ item.article.created_at_pretty }}</span>
            </div>
            <button class="close-btn fa-button" (click)="removeArticle(item, $event)" aria-label="remove article">
              <fa-icon icon="times-circle"></fa-icon>
            </button>
          </button>
        }
      </div>
    }
    @if (msgInput.selectedLearnContentInMessage && msgInput.selectedLearnContentInMessage.length) {
      <div class="m-y-20">
        @for (item of msgInput.selectedLearnContentInMessage; track item) {
          @if (item.content.type == "video") {
            <div class="grid-container wider pad-10">
              <myp-video-grid-item [showBorder]="true" [video]="item.content" [showRemoveFromPost]="true" (removeFromPostClicked)="removeLearnContent(item, $event)"></myp-video-grid-item>
            </div>
          }
          @if (item.content.type != "video") {
            <myp-learn-list-item
              [shouldShowButtons]="false"
              [showRemoveFromPost]="true"
              [item]="item.content"
              [preventNav]="true"
              (removeFromPostClicked)="removeLearnContent(item, $event)"
            ></myp-learn-list-item>
          }
        }
      </div>
    }
    @if (msgInput.publicFileLinksInMessage && msgInput.publicFileLinksInMessage.length) {
      <div class="m-y-20">
        @for (item of msgInput.publicFileLinksInMessage; track item) {
          @for (item of msgInput.publicFileLinksInMessage; track item) {
            <div class="comment-article-attachment">
              <fa-icon [icon]="workspaceService.audioFiles[item.publicFile.extension] ? 'play-circle' : 'file'" class="icon"></fa-icon>
              <div>
                <span class="bold">{{ item.publicFile.filename }}</span>
                <br />
                <span class="t-12 text-muted">{{ item.publicFile.description }}</span>
              </div>
              <button class="close-btn fa-button" (click)="removePublicFile(item, $event)" aria-label="Remove public file">
                <fa-icon icon="times-circle"></fa-icon>
              </button>
            </div>
          }
        }
      </div>
    }
    @if (msgInput.messageEmbeds && msgInput.messageEmbeds.length) {
      <div class="d-flex flex-column">
        @for (embed of msgInput.messageEmbeds; track embed) {
          <div class="message-embed message-embed--{{ embed.type }} message-embed--{{ embed.subtype }}">
            <button class="close-btn fa-button" (click)="removeEmbed(item, $event)" aria-label="Remove Embed">
              <fa-icon icon="times-circle"></fa-icon>
            </button>
            <iframe width="560" height="315" [src]="embed.embedSrc" frameborder="0" allowfullscreen></iframe>
          </div>
        }
      </div>
    }
    @if (uploadingFiles && uploadingFiles.length && createPostActive) {
      <div class="w-100">
        @for (file of uploadingFiles; track file) {
          <span class="text-muted t-14">{{ "general.uploading" | translate }}: {{ file.filename }} {{ file.progress }}%</span>
          <div class="post-progress-bar" [ngStyle]="{ width: (file.progress ? file.progress : 0) + '%' }"></div>
        }
      </div>
    }
    @if (uploadedAttachments && uploadedAttachments.length && createPostActive) {
      <div class="d-flex flex-wrap">
        @for (attachment of uploadedAttachments; track attachment) {
          <div class="attachment">
            @if (workspaceService.imageFiles[attachment.extension]) {
              <img [src]="attachment.url" class="image-border" style="width: 200px" alt="attachment image" />
            }
            @if (workspaceService.audioFiles[attachment.extension]) {
              <audio id="audio_player" controls="true">
                <source [src]="attachment.url" type="audio/wav" />
              </audio>
            }
            @if (!workspaceService.audioFiles[attachment.extension] && !workspaceService.imageFiles[attachment.extension]) {
              <span class="gothic t-18">
                <fa-icon icon="file" class="m-r-10"></fa-icon>
                <span>{{ attachment.filename }}</span>
              </span>
            }
            <button class="remove fa-button" (click)="removeAttachment(attachment)"><fa-icon icon="times-circle" class="c-red"></fa-icon></button>
          </div>
        }
      </div>
    }
    @if (createPostActive) {
      <div class="d-flex justify-content-between align-items-center m-y-10">
        @if (!uploadingFile) {
          <div class="d-flex align-items-center justify-content-between w-full">
            <ul class="d-flex align-items-center attachment-list">
              <li>
                <span class="d-block m-r-10 t-12 bold">Attach:</span>
              </li>
              <li>
                <button class="fa-button" (click)="attachFile()" [ngbTooltip]="'File'">
                  <fa-icon class="circle-icon-btn m-r-5" icon="file"></fa-icon>
                  <span class="sr-only">File</span>
                </button>
              </li>
              <li>
                <button class="fa-button" (click)="showAttach('videos')" [ngbTooltip]="'Video'">
                  <fa-icon class="circle-icon-btn m-r-5" icon="video"></fa-icon>
                  <span class="sr-only">Video</span>
                </button>
              </li>
              <li>
                <button class="fa-button" (click)="showAttach('articles')" [ngbTooltip]="'Article'">
                  <fa-icon class="circle-icon-btn m-r-5" icon="newspaper"></fa-icon>
                  <span class="sr-only">Article</span>
                </button>
              </li>
            </ul>
            @if (features.schedulePostsForBeta && betaStringId && !scheduledPost) {
              <button class="brand-btn-reverse sm" (click)="onScheduleChange($event)">Schedule Post</button>
            }
            @if (scheduledPost) {
              <div>
                <span class="t-12">
                  <fa-icon icon="times-circle" class="c-red m-r-5 pointer" (click)="onScheduleChange($event)"></fa-icon>
                  <fa-icon icon="clock" class="c-official-blue"></fa-icon>
                  Scheduled for {{ scheduledPostDate | date: "MMM Do" }} at {{ scheduledPostDate | date: "h:mma" }}
                </span>
              </div>
            }
          </div>
        }
        @if (userService.user.is_sphere_admin || userService.isEmployee) {
          <div class="t-12">
            @if (userService.user.is_sphere_admin && !betaStringId) {
              <div>
                <label>
                  <input type="checkbox" [(ngModel)]="sphereOnlyPost" />
                  &nbsp; Only show in {{ env.studioOnePlusBrandName }}
                </label>
              </div>
            }
            @if (userService.isEmployee && !betaStringId) {
              <div>
                <label>
                  <input type="checkbox" [(ngModel)]="employeeOnlyPost" />
                  &nbsp; Only show to employees
                </label>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (betaStringId && isBetaManager && createPostActive) {
      <div class="t-12">
        <div class="m-b-10">
          <button class="small-btn" (click)="populateBetaPostTemplate()">Inject Issue Template</button>
        </div>
        <div>
          <label>
            <input type="checkbox" [(ngModel)]="pinToBetaProgram" />
            &nbsp; Pin to top of Beta Program
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox" [(ngModel)]="sendBetaProgramAnnouncementEmail" />
            &nbsp; Send an email with the contents of this post to every participant of {{ betaStringId }} program.
          </label>
        </div>
      </div>
    }
    @if (createPostActive) {
      <div class="m-t-10 d-flex align-items-end justify-content-between position-relative">
        <div class="d-flex flex-wrap align-items-center">
          @if (topic) {
            <span class="t-12 text-muted">Topic:</span>
            <span class="create-post-selected-channel">{{ topic.title }}</span>
          }
          <span class="t-12 text-muted" [class.m-l-10]="topic">{{ "com.channels" | translate }}:</span>
          @if (!betaStringId && !topic && !selectedChannels.length) {
            <span class="create-post-selected-channel">{{ "com.skills.general" | translate }}</span>
          }
          @for (channel of selectedChannels; track channel) {
            <span class="create-post-selected-channel">
              # {{ betaStringId ? channel.title : ("com.skills." + channel.string_id | translate) }}
              <button class="m-l-5 fa-button" (click)="removeChannel(channel)">
                <fa-icon icon="times-circle"></fa-icon>
                <span class="sr-only">Remove Channel</span>
              </button>
            </span>
          }
          @if (!selectedChannels || selectedChannels.length < 3) {
            <button
              class="add-channel-button c-lblue bold pointer"
              aria-controls="channel-list"
              [attr.aria-expanded]="shouldShowChannelSelector"
              (click)="shouldShowChannelSelector = !shouldShowChannelSelector"
            >
              {{ "com.add_channel" | translate }}
              <fa-icon icon="plus-circle" class="c-lblue t-14"></fa-icon>
            </button>
          }
        </div>
        <button class="send-btn no-margin" (click)="sendPost()" [class.disabled]="!postContent">{{ "general.send" | translate | uppercase }}</button>
      </div>
    }
    @if (shouldShowChannelSelector) {
      <div class="channel-selector" id="channel-list" (clickOutside)="shouldShowChannelSelector = false">
        @if (!betaStringId) {
          <div class="channel-list overflow-auto h-100">
            @for (skill of communityService.taggableChannels; track skill) {
              <button class="channel-button bold pointer t-14 p-1" (click)="addChannel(skill)">
                <fa-icon icon="hashtag" class="c-lblue"></fa-icon>
                {{ "com.skills." + skill.string_id | translate }}
              </button>
            }
          </div>
        }
        @if (betaStringId) {
          <div class="channel-list overflow-auto h-100">
            @for (tag of betaService.communityTags; track tag) {
              <button class="channel-button bold pointer t-14 p-1" (click)="addChannel(tag)">
                <fa-icon icon="hashtag" class="c-lblue"></fa-icon>
                {{ tag.title }}
              </button>
            }
          </div>
        }
      </div>
    }
  }
  @if (user.active_subscription && communityService.profile && !communityService.profile.public && !betaStringId) {
    <div class="warning text-center">
      <p>{{ "com.profile_needs_public" | translate }}</p>
      <a class="small-btn blue" role="link" (click)="makePublic()">{{ "com.make_public" | translate }}</a>
    </div>
  }
  @if (!user.active_subscription && !betaStringId) {
    <div class="warning text-center">
      <fui-heading [text]="'sphere.welcome.welcome' | translate" textAlign="center" fontSize="f6" level="2"></fui-heading>
      <p>
        {{ "com.free_browse" | translate: { appName: "My Fender", subName: env.studioOnePlusBrandName } }}
      </p>
      <ul class="list-inline">
        <li class="list-inline-item">
          <a class="small-btn blue" role="link" (click)="upgrade()">{{ "newdash.get_sphere" | translate: { subName: env.studioOnePlusBrandName } }}</a>
        </li>
        <li class="list-inline-item">
          <a class="small-btn blue" role="link" (click)="watchVideo()">{{ "newdash.watch_short_video" | translate }}</a>
        </li>
      </ul>
    </div>
  }
  @if (createPostActive) {
    <button type="button" class="btn btn-transparent p-0" style="position: absolute; top: -11px; right: -6px" (click)="cancelCreatePost()">
      <fa-icon icon="times-circle" class="t-20" aria-hidden="true"></fa-icon>
      <span class="sr-only">cancel create post</span>
    </button>
  }
</div>

<ng-template #confirmPublicPostModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="hardware-history-details">Please confirm</h4>
    <button ngbAutofocus class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    You are currently attempting to post in the public Community. This means that your post will be visible to all users. You are enrolled in the following Beta Programs, so please confirm that you
    would like to post publicly.

    @for (beta of betaService.enrolledBetaFeatures; track beta) {
      <div class="m-y-20">
        <strong>{{ beta.title }}</strong>
        <a class="btn btn-primary" [routerLink]="['/beta/' + beta.string_id + '/channels/all_posts']" (click)="moveToBeta(); modal.dismiss('Cross click')">Post in {{ beta.title }} instead.</a>
      </div>
    }

    <hr />
    <br />
    <button class="btn btn-primary" (click)="modal.dismiss('Cross click'); sendPost(false, true)">Post in Public Community</button>
  </div>
</ng-template>
